import { takeLatest, put } from 'redux-saga/effects';
import { CLOSE_EVENTS, OPEN_EVENTS } from '../constants/event.constants';
import { EventAPI } from '../../utils/API/EventAPI';
import { updateEvent } from '../actions/event.actions';
import { consoleWarn } from '../../utils/log';

const eventAPI: EventAPI = new EventAPI();

// The alarm bulk action dispatches both close actions whatever is selected, and an
// empty list still PUT to the V3 endpoint — which 401s on a V4 account. These are
// attached children of appSaga, so an uncaught error cancels every sibling watcher.
function* closeEvents({events}) {
	if (!events?.length) return;
	yield disableEvents(events);
	try {
		yield eventAPI.closeEvents(events);
	} catch (e) {
		consoleWarn('Failed to close events', e);
	}
}

function* openEvents({events}) {
	if (!events?.length) return;
	yield disableEvents(events);
	try {
		yield eventAPI.openEvents(events);
	} catch (e) {
		consoleWarn('Failed to reopen events', e);
	}
}

function* disableEvents(events: Event[]) {
	for(let i in events) {
		yield put(updateEvent(events[i].set('disabled', true).toJS()));
	}
}

export const eventSagas = [
	takeLatest(OPEN_EVENTS, openEvents),
	takeLatest(CLOSE_EVENTS, closeEvents),
];